import {longMonth} from './FormatMonth';

export const GetAnalyticsStateName = state => {
    //
    if (state === 'app-cover') {
        return 'The Page Cover';
    }
    if (state.match(/event-cover-\d+/)) {
        return `the Cover of '${longMonth(parseInt(state.substr(12)))}'`;
    }
    if (state.match(/event-\d+/)) {
        return `the Cover of '${longMonth(parseInt(state.substr(6)))}'`;
    }

    return '';
};
